module.exports = "/lucky-balls/img/drum/drum_loop_038.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_038.png
// module id = 1053
// module chunks = 0